const DEFAULT_ERROR = 'Une erreur imprévue est survenue, veuillez réessayer.';
export default function getErrorsFromResponse({
  response = {},
  error
}) {
  error = error || DEFAULT_ERROR;
  let update = {
    loading: false,
    info: undefined,
    error: response?.error || error,
    warning: response?.warning,
    error_type: response?.error_type || undefined,
    E_CODE: response.E_CODE || undefined,
    status_messages: response?.fields || {}
  };
  return update;
}
